import {useQuery} from '@tanstack/react-query';
import {rqCreateRequest, rqCreateSearchRequest} from './rqHttpsUtils';
import {
  RQ_CREATE_DIVISION_API,
  RQ_GET_DIVISION_BY_ID_API,
  RQ_GET_DIVISION_LIST_API, RQ_GET_LOCATION_EMPLOYEE_LIST_BY_DIVISION_API,
  RQ_GET_SEARCH_DIVISION_API,
  RQ_UPDATE_DIVISION_ALL_FIELDS_API,
} from './constants';

export const RQPostCreateDivision = async ({
  division,
  token,
  signal,
}) => {
  return rqCreateRequest(
    RQ_CREATE_DIVISION_API,
    JSON.stringify({...division}),
    token,
    null,
    signal,
  );
};

export const RQUseGetDivisionListData = payload => {
  return useQuery(
    ['rq_get_division_list_data', payload],
    async ({queryKey, signal}) => {
      const {token} = queryKey[1];

      return rqCreateRequest(
        RQ_GET_DIVISION_LIST_API,
        null,
        token,
        null,
        signal,
      );
    },
    {
      cacheTime: 2 * 60 * 1000, // 2 min
    },
  );
};

export const RQUseGetDivisionByIdData = payload => {
  return useQuery(
    ['rq_get_division_by_id_data', payload],
    async ({queryKey, signal}) => {
      const {id, token} = queryKey[1];

      return rqCreateRequest(
        RQ_GET_DIVISION_BY_ID_API,
        null,
        token,
        {id:id},
        signal,
      );
    },
    {
      cacheTime: 0,
    },
  );
};

export const RQPutDivisionUpdateAllField = async ({
  division,
  token,
  signal,
  id,
}) => {
  return rqCreateRequest(
    RQ_UPDATE_DIVISION_ALL_FIELDS_API,
    JSON.stringify({...division, id:id}),
    token,
    null,
    signal,
  );
};

export const RQUseGetSearchDivisionData = payload => {
  return useQuery(
    ['rq_get_search_division_data', payload],
    async ({queryKey, signal}) => {
      const {token, filter} = queryKey[1];

      return rqCreateSearchRequest(
        RQ_GET_SEARCH_DIVISION_API,
        null,
        token,
        null,
        signal,
        filter,
      );
    },
    {
      cacheTime: 0,
    },
  );
};

export const RQUseGetLocationEmployeeListByDivision = payload => {
  return useQuery(
    ['rq_get_location_employee_list_by_division', payload],
    async ({queryKey, signal}) => {
      const {token} = queryKey[1];
      return rqCreateRequest(
        RQ_GET_LOCATION_EMPLOYEE_LIST_BY_DIVISION_API,
        null,
        token,
        null,
        signal,
      );
    },
    {
      cacheTime: 0,
    },
  );
};
